class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const textElement = document.querySelector('.js-mv-text');
    const textNodes = Array.from(textElement.childNodes);
    
    textElement.innerHTML = '';
    
    let newContent = '';
    
    textNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        newContent += text.split('').map(char => `<span>${char === ' ' ? '&nbsp;' : char}</span>`).join('');
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        newContent += node.outerHTML;
      }
    });
    
    textElement.innerHTML = newContent;
    
    
    gsap.set(".js-header", { opacity: 0 });
    gsap.set(".js-mv-content", { opacity: 0 });
    gsap.set(".js-mv-news", { opacity: 0 });
    gsap.set(".js-mv-text span", { opacity: 0, y: -20 });

    const tl = gsap.timeline();

    tl.to(".js-mv-content", { opacity: 1, duration: 1, ease: "power2.out" }, 0)
    .to(".js-mv-text span", { opacity: 1, y: 0, stagger: 0.06, duration: 0.8, ease: "power2.out" },)
    .to(".js-header", { opacity: 1, duration: 0.7, ease: "power2.out" }, "+=0.2")
    .to(".js-mv-news", { opacity: 1, duration: 0.7, ease: "power2.out" }, "<")
  

    function setScrollPosition() {
      if ($('.js-fixed-body').data('scroll-set')) return;
      const scrollPosition = $('.js-wave-point05').offset().top 
        + ($('.js-wave-point05').outerHeight() / 2) 
        + ($(window).height() / 2);
      $('.js-fixed-body').css('height', scrollPosition + 'px');
      $('.js-fixed-body').data('scroll-set', true);
    }
    
    setScrollPosition();

    const windowWidth = window.innerWidth;
    gsap.registerPlugin(ScrollTrigger);
    
    if (windowWidth < 768) {
      gsap.set(".js-fixed-wave", {
        scale: 1,
        left: "20%",
        xPercent: -70,
        yPercent: -70,
      });

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: ".p-top",
          start: "top top",
          end: "bottom bottom",
          scrub: 2,
        },
      });
      
      timeline
        .to(".js-fixed-wave", {
          scale: 0.5,
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.673,
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          opacity: 0,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.8,
          left: "0%",
          xPercent: 130,
          yPercent: 0,
          opacity: 1,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.63,
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.422,
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          ease: "Power0.easeNone",
        }); 
    
    } else if (windowWidth < 2000) {
      gsap.set(".js-fixed-wave", {
        scale: 1,
        left: 0,
        xPercent: -30,
      });

      
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: ".p-top",
          start: "top top",
          end: "bottom bottom",
          scrub: 4,
        },
      });
      
      timeline
        .to(".js-fixed-wave", {
          scale: 0.636,
          left: "50%",
          xPercent: -50,
          opacity: 0.8,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 1.2,
          left: "150%",
          xPercent: 0,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          left: "4%",
          xPercent: 0,
          delay: 1,
          duration: 1,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.32,
          ease: "Power0.easeNone",
          duration: 1.8
        },'<')
        .to(".js-fixed-wave", {
          scale: 0.388,
          top: "0",
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          ease: "Power0.easeNone",
          opacity: 0.5,
          delay: 0.4
        });    

    } else {
      gsap.set(".js-fixed-wave", {
        scale: 1.3,
        left: "0%",
        xPercent: -30,
      });
      
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: ".p-top",
          start: "top top",
          end: "bottom bottom",
          scrub: 4,
        },
      });
      
      timeline
        .to(".js-fixed-wave", {
          scale: 0.636,
          left: "50%",
          xPercent: -50,
          opacity: 0.8,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 1.2,
          left: "150%",
          xPercent: 0,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.32,
          left: "-10%",
          xPercent: 0,
          delay: 1,
          ease: "Power0.easeNone",
        })
        .to(".js-fixed-wave", {
          scale: 0.388,
          top: "0",
          left: "50%",
          xPercent: -50,
          yPercent: 0,
          ease: "Power0.easeNone",
          opacity: 0.5,          
        });    
    }

  }
}
